(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nos-salons"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const slider = document.querySelector('.salons-slider');
  const prevBtn = document.querySelector('.slider-prev');
  const nextBtn = document.querySelector('.slider-next');
  const cards = document.querySelectorAll('.salon-card');
  let index = 0;

  function getVisibleCount() {
    if (window.innerWidth <= 600) return 1;
    if (window.innerWidth <= 992) return 2;
    return 3;
  }

  function updateSlider() {
    const visibleCards = getVisibleCount();
    const slideWidth = cards[0].offsetWidth;
    const maxIndex = cards.length - visibleCards;
    index = Math.max(0, Math.min(index, maxIndex));
    slider.style.transform = `translateX(-${index * slideWidth}px)`;
  }

  nextBtn.addEventListener('click', () => {
    const visibleCards = getVisibleCount();
    if (index < cards.length - visibleCards) index++;
    updateSlider();
  });

  prevBtn.addEventListener('click', () => {
    if (index > 0) index--;
    updateSlider();
  });

  window.addEventListener('resize', updateSlider);
  updateSlider();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonial-barbiere"] && !Shopify.designMode) return;
  try {
    
var swiper = new Swiper('.testimonial-swiper', {
  slidesPerView: 3,
  spaceBetween: 30,
  loop: true,
  speed: 800,
  autoplay: {
    delay: 2500,
    disableOnInteraction: false,
  },
  breakpoints: {
    0: { slidesPerView: 1, spaceBetween: 15 },
    768: { slidesPerView: 2, spaceBetween: 20 },
    1024: { slidesPerView: 3, spaceBetween: 30 }
  }
});

  } catch(e) { console.error(e); }
})();
})();
